import React, {Component} from 'react';
import classNames from 'classnames';
import './FJToolbarCommon.less';
import FJMediaStatusToolbarView from "./FJMediaStatusToolbarView";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJLocalStore from "../../../store/FJLocalStore";
import RetryIcon from '../../../icon/retry.svg';
import LinkIcon from '../../../icon/relink-color.svg';

class FJToolbarCommon extends Component {

	getCorrespondingComponent = () => {
		let {mediaStatus, mediaName, onRetryFun, onLinkFun} = this.props;

		switch (mediaStatus) {
			case FJViewConstant.MEDIA_STATUS_RETRY:
				return <FJMediaStatusToolbarView text={FJLocalStore._('retry')}
																				 icon={RetryIcon}
																				 info={mediaName}
																				 onClick={onRetryFun}
				/>
			case FJViewConstant.MEDIA_STATUS_LINK:
				return <FJMediaStatusToolbarView text={FJLocalStore._('relink')}
																				 icon={LinkIcon}
																				 info={mediaName}
																				 onClick={onLinkFun}
				/>
			default:
				return this.props.children
		}
	}

	render() {
		let {className} = this.props;
		if (className) {
			className = className.split(/\s+/);
		}
		let containerClass = classNames('c-toolbar-common', className);
		return (
			<div className={containerClass}>
				{
					this.getCorrespondingComponent()
				}
			</div>
		);
	}
}

export default FJToolbarCommon;
